import { Breadcrumbs } from "@mui/material";
import React from "react";
import { useLocation, Link, useSearchParams } from "react-router-dom";
import { APP_PAGES } from "../../pages";
import { filterTypes } from "../../Utils/helper";

const getSearchKeywords = (searchParams: URLSearchParams): string[] => {
  const keywords: string[] = [];
  const query = searchParams.get("query")?.trim();
  if (query) {
    keywords.push(query);
  }

  Object.values(filterTypes).forEach((paramName) => {
    const raw = searchParams.get(paramName as string);
    if (!raw) return;
    raw.split("|").forEach((tag) => {
      const value = tag.trim();
      if (value) keywords.push(value);
    });
  });

  return keywords;
};

const Breadcrumb = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  if (location.pathname === APP_PAGES.SEARCH) {
    const keywords = getSearchKeywords(searchParams);

    if (keywords.length === 0) {
      return null;
    }

    const label = keywords.length === 1 ? keywords[0] : "Search";

    return (
      <Breadcrumbs separator={<>&nbsp;{">"}&nbsp;</>} aria-label="breadcrumb">
        <Link to={APP_PAGES.SEARCH} className="active">
          Home
        </Link>
        <Link to={APP_PAGES.SEARCH} className="inactive">
          {label}
        </Link>
      </Breadcrumbs>
    );
  }

  return (
    <Breadcrumbs separator={<>&nbsp;{">"}&nbsp;</>} aria-label="breadcrumb">
      {location.pathname.split("/").map((item, i) => (
        <Link
          key={i}
          to={item === "" ? APP_PAGES.SEARCH : "/" + item}
          className={
            location.pathname.split("/").length - 1 === i
              ? "inactive"
              : "active"
          }
        >
          {item === ""
            ? "Home"
            : decodeURIComponent(item).split("-").join(" ")}
        </Link>
      ))}
    </Breadcrumbs>
  );
};

export default Breadcrumb;
